import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  return _openBlock(), _createBlock(_component_el_upload, {
    name: "file",
    "file-list": _ctx.fileListAll,
    "onUpdate:fileList": _cache[0] || (_cache[0] = $event => _ctx.fileListAll = $event),
    headers: _ctx.headers,
    action: "/ty-iot-manage/api/v1/file/upload",
    "list-type": "picture-card",
    "on-remove": _ctx.handleRemove,
    limit: $props.limit,
    "on-success": _ctx.handleAvatarSuccess,
    "on-exceed": _ctx.handleExceed,
    "before-upload": _ctx.beforeAvatarUpload
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Plus)]),
      _: 1
    })]),
    _: 1
  }, 8, ["file-list", "headers", "on-remove", "limit", "on-success", "on-exceed", "before-upload"]);
}